import {action, computed, makeObservable, observable} from "mobx";

export default class TemplateEditorFormStore {
  fromDomain = null;
  senderName = null;
  to = null;
  subject = null;
  cc = null;
  bcc = null;
  description = null;

  validateSenderName = "";

  constructor() {
    makeObservable(this, {
      fromDomain: observable,
      senderName: observable,
      to: observable,
      subject: observable,
      cc: observable,
      bcc: observable,
      description: observable,
      from: computed,
      currentSubject: computed,
      updateField: action,
      updateFrom: action,
      updateSenderName: action,
      clean: action,
    });
  }

  get currentSubject() {
    return this.subject;
  }

  get from() {
    return `${this.senderName}@${this.fromDomain}`;
  }

  updateField(field, value) {
    this[field] = value;
  }

  updateFrom(value){
    const [senderName, fromDomain] = value.split('@');
    this.senderName = senderName;
    this.fromDomain = fromDomain;
  }

  updateSenderName(){
    this.validateSenderName = "";

    const value = this.senderName.toLowerCase().trim().replace(/\s+/g, '-');

    if (/[^a-z0-9-]/.test(value)) {
      this.validateSenderName = 'Sender name contains invalid characters';
    }

    if (value.length > 50) {
      this.validateSenderName = 'Sender name exceeds 50 characters';
    }

    this.senderName = value;
  }

  clean() {
    this.fromDomain = null;
    this.senderName = null;
    this.to = null;
    this.subject = null;
    this.cc = null;
    this.bcc = null;
    this.description = null;
  }
}